import { NotificationsState, NotificationData } from './types';

export default {
  allNotifications: (state: NotificationsState): NotificationData[] => {
    return state.notifications;
  },

  notificationCount: (state: NotificationsState): number => {
    return state.notifications.length;
  },

  hasNotifications: (state: NotificationsState): boolean => {
    return state.notifications.length > 0;
  },

  getNotificationById: (state: NotificationsState) => (id: string): NotificationData | undefined => {
    return state.notifications.find(n => n.id === id);
  },
};

